module.exports = __webpack_public_path__ + "img/level-ranked.39f49841.svg";